/**
 * Created by mac on 10/5/20
 */

const AdminLevelsView = cc.Node.extend({
    ctor: function (adminLevels, mode) {
        this._super();

        this.adminLevels = adminLevels;

        this.mode = mode;

        const size = cleverapps.resolution.getSceneSize();

        this.setContentSize2(cleverapps.styles.AdminLevelsView.width, size.height);
        this.setAnchorPoint(0.5, 0.5);

        this.adminLevels.on("reset", this.reset.bind(this), this);
        this.adminLevels.on("addLevel", this.addLevel.bind(this), this);
        this.adminLevels.on("downloadLevels", this.downloadLevels.bind(this), this);
        this.adminLevels.on("changeActive", this.onSetActive.bind(this), this);

        const nodes = [];

        const log = this.log = new AdminLogView();
        nodes.unshift(this.wrapWithBg(log));

        this.levelsArea = new cc.Node();
        this.levelsArea.setContentSize2(this.width, cleverapps.styles.AdminLevelsView.levels.height);
        nodes.unshift(this.wrapWithBg(this.levelsArea));

        const chartWrapper = this.getChartWrapper();
        nodes.unshift(this.wrapWithBg(chartWrapper, cleverapps.styles.AdminLevelsView.bg.chart));

        const layout = new cleverapps.Layout(nodes, {
            direction: cleverapps.UI.VERTICAL,
            margin: cleverapps.styles.AdminLevelsView.margin
        });
        layout.setAnchorPoint(0, 1);
        layout.setAlignment(0, this.height - 15);
        this.addChild(layout);

        this.createLanguageButtons();
        this.createControlButtons();
        this.transferFileButtons();

        this.reset();
    },

    wrapWithBg: function (node, options) {
        options = options || {};

        const styles = cleverapps.styles.AdminLevelsView.bg;
        const paddingY = options.paddingY || styles.paddingY;
        const dx = options.dx || 0;
        const dy = options.dy || 0;

        const bg = cleverapps.UI.createScale9Sprite(bundles.admin.frames.common_bg, cleverapps.UI.Scale9Rect.TwoPixelXY);
        bg.addChild(node);
        bg.setContentSize2(this.width, node.height + paddingY);
        node.setAlignment(bg.width / 2 + dx, bg.height / 2 + dy);
        return bg;
    },

    getChartWrapper: function () {
        const wrapper = new cc.Node();
        wrapper.setAnchorPoint(0.5, 0.5);
        wrapper.setContentSize2(this.width - cleverapps.styles.AdminLevelsView.chart.paddingX, cleverapps.styles.AdminLevelsView.chart.height);

        let chart = undefined;
        const onStatisticsLoaded = function (data) {
            chart = new AdminLevelsChart(data, wrapper);
            cleverapps.UI.fitToBox(chart, wrapper.getContentSize());
            chart.setAlignment(wrapper.width / 2, wrapper.height / 2);
            wrapper.addChild(chart);
        };
        this.adminLevels.on("statisticsLoaded", onStatisticsLoaded, this);
        if (this.adminLevels.episodeStatistics.ready) {
            onStatisticsLoaded(this.adminLevels.episodeStatistics.getData());
        }

        this.adminLevels.on("statisticsReset", () => {
            if (chart) {
                chart.removeFromParent(true);
                chart = undefined;
            }
        }, this);

        return wrapper;
    },

    reset: function () {
        if (this.levelsScroll) {
            this.levelsScroll.removeFromParent(true);
            delete this.levelsScroll;
        }

        this.levelsList = this.getLevelsList();
        cleverapps.UI.wrapWithPadding(this.levelsList, cleverapps.styles.AdminLevelsView.levels.padding, true);

        this.levelsScroll = new cleverapps.UI.ScrollView(this.levelsList);
        this.levelsScroll.setContentSize2(this.width, cleverapps.styles.AdminLevelsView.levels.height);
        this.levelsArea.addChild(this.levelsScroll);

        this.onSetActive(true);
    },

    getLevelsList: function () {
        const levelsList = new cc.Node();
        levelsList.setAnchorPoint(0.5, 0.5);

        this.slots = [];

        this.adminLevels.levels.forEach((adminLevel, levelNo) => {
            const slot = new AdminLevelSlotView(adminLevel);
            slot.setAlignment(this.alignInTheGrid(levelNo));
            levelsList.addChild(slot);
            this.slots.push(slot);

            const view = AdminLevelView.create(adminLevel, this);
            view.setAlignment(slot.width / 2, slot.height / 2);
            slot.addChild(view);

            if (!adminLevel.isAddMoreLevel()) {
                adminLevel.on("update", () => {
                    this.slots[adminLevel.levelNo].updateAdminLevel(adminLevel);
                }, levelsList);
            }
        });

        cleverapps.UI.wrap(levelsList);

        return levelsList;
    },

    addLevel: function () {
        this.reset();
    },

    getNearestSlotIndex: function (worldPosition) {
        const position = this.levelsList.convertToNodeSpace(worldPosition);
        let minDist = Number.MAX_VALUE;
        let index = 0;
        for (let i = 0; i < this.slots.length - 1; i++) {
            const slot = this.slots[i];
            const dist = cc.pDistance(position, slot.getPosition());
            if (dist < minDist) {
                minDist = dist;
                index = i;
            }
        }

        return index;
    },

    createLanguageButtons: function () {
        if (!cleverapps.administrator.adminLanguages) {
            return;
        }

        const styles = cleverapps.styles.AdminLevelsView.languageBlock;

        const width = (styles.width + styles.margin - styles.padding.x * 2) / cleverapps.config.languages.length - styles.margin;
        const views = Object.values(cleverapps.administrator.adminLanguages).map((adminLanguage) => new AdminLanguageView(adminLanguage, { width }));

        const layout = new cleverapps.Layout(views, {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.margin,
            padding: styles.padding
        });

        layout.setAlignment(styles);
        this.addChild(layout);
    },

    createControlButtons: function () {
        const styles = cleverapps.styles.AdminLevelsView.controlButtons;
        const buttonOptions = [];

        if (cleverapps.config.name === "scramble") {
            buttonOptions.push({
                icon: bundles.admin.frames.update_icon,
                hint: "Update googlesheets",
                action: function () {
                    cleverapps.focusManager.display({
                        focus: "AdminUpdateGooglesheetsWindow",
                        action: function (f) {
                            new AdminUpdateGooglesheetsWindow();
                            cleverapps.focusManager.onceNoWindowsListener = f;
                        }
                    });
                }
            });
        }

        const buttons = [new AdminDebugButton()];

        if (["tile3"].indexOf(cleverapps.config.type) !== -1) {
            buttons.unshift(new AdminPasteClipboardButton());
        }

        const views = buttons.concat(buttonOptions.map((data) => new cleverapps.UI.Button({
            type: cleverapps.styles.UI.Button.Images.editor,
            content: new cc.Sprite(data.icon),
            width: styles.width,
            height: styles.height,
            onClicked: data.action,
            hint: data.hint,
            hintLocation: cleverapps.UI.Tooltip.LOCATION_BELOW
        })));

        const layout = new cleverapps.Layout(views, {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin,
            reversed: true
        });

        layout.setAlignment(styles);
        this.addChild(layout);
    },

    transferFileButtons: function () {
        const styles = cleverapps.styles.AdminLevelsView.transferFileButtons;

        const uploadButton = new cleverapps.UI.Button({
            type: cleverapps.styles.UI.Button.Images.editor,
            content: new cc.Sprite(bundles.admin.frames.upload_icon),
            width: styles.width,
            height: styles.height,
            onClicked: function () {
                cleverapps.focusManager.display({
                    focus: "UploadLevels",
                    action: function (f) {
                        const element = document.createElement("input");
                        element.setAttribute("type", "file");
                        element.setAttribute("id", "uploadLevels");
                        element.style.display = "none";
                        document.body.appendChild(element);
                        element.click();

                        element.addEventListener("change", (event) => {
                            this.adminLevels.upload(event, f);
                        });
                    }.bind(this)
                });
            }.bind(this),
            hint: "Upload levels"
        });

        const downloadButton = new cleverapps.UI.Button({
            type: cleverapps.styles.UI.Button.Images.editor,
            content: new cc.Sprite(bundles.admin.frames.download_icon),
            width: styles.width,
            height: styles.height,
            onClicked: function () {
                cleverapps.focusManager.display({
                    focus: "DownloadLevels",
                    action: function (f) {
                        this.adminLevels.download(f);
                    }.bind(this)
                });
            }.bind(this),
            hint: "Download levels"
        });

        const layout = new cleverapps.Layout([uploadButton, downloadButton], {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });

        layout.setAlignment(styles);
        this.addChild(layout);
    },

    downloadLevels: function (options) {
        const data = options.data;
        const fileName = options.fileName;

        const element = document.createElement("a");
        element.setAttribute("href", `data:text/json;charset=utf-8,${encodeURIComponent(data)}`);
        element.setAttribute("download", fileName);
        element.style.display = "none";
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    },

    switchMode: function (mode) {
        this.reset(mode);
    },

    alignInTheGrid: function (index) {
        const styles = cleverapps.styles.AdminLevelsView;

        const marginCol = styles.marginCol;
        const marginRow = styles.marginRow;
        const availableWidth = styles.width;
        const size = styles.cellSize;

        const perRow = Math.floor(availableWidth / (size.width + marginCol));

        const col = index % perRow;
        const row = Math.floor(index / perRow);

        return cc.p(
            size.width / 2 + col * (size.width + marginCol),
            (this.levelsList ? this.levelsList.height : 0) - size.height / 2 - row * (size.height + marginRow) - styles.paddingTop
        );
    },

    onSetActive: function (silent) {
        this.slots.forEach((slot) => {
            if (slot.adminLevel.selected) {
                if (silent) {
                    this.levelsScroll.scrollTo(slot, 0);
                } else {
                    this.levelsScroll.stopAutoScroll();
                    this.levelsScroll.runAction(new cc.ScrollAction(slot, {
                        duration: 0.2,
                        visibleBox: {
                            top: 0.85,
                            bottom: 0.85
                        }
                    }));
                }
            }
        });
    }
});

cleverapps.styles.AdminLevelsView = {
    paddingTop: 50,
    margin: 3,
    marginCol: 10,
    marginRow: 70,

    levels: {
        height: 783,
        padding: {
            top: 40,
            right: 40
        }
    },

    chart: {
        paddingX: 100,
        height: 300
    },

    width: 880,

    cellSize: {
        width: 140,
        height: 220
    },

    languageBlock: {
        x: { align: "center", dx: 0 },
        y: { align: "top", dy: -310 },
        width: 530,
        margin: 2,
        padding: {
            x: 0,
            y: 10
        }
    },

    controlButtons: {
        x: { align: "right", dx: -25 },
        y: { align: "top", dy: -54 },
        margin: 2,
        width: 45,
        height: 45
    },

    transferFileButtons: {
        x: { align: "right", dx: -25 },
        y: { align: "top", dy: -200 },
        margin: 2,
        width: 45,
        height: 45
    },

    bg: {
        paddingY: 10,

        chart: {
            paddingY: 43,
            dx: -30,
            dy: 15
        }
    }
};